import { reactive, computed, onMounted, onUpdated, onBeforeUnmount, resolveComponent, openBlock, createElementBlock, normalizeClass, createVNode, withCtx, createElementVNode, Fragment, createBlock, createCommentVNode, toDisplayString, createApp } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import Popup from './popup';
import Icon from './icon';
import Loading from './loading';
import { toast } from '@kid/sharpui/widget/output/all/tokens';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * kid token
   */
  token: propTypes.string(),
  status: propTypes.string().def('info'),
  content: propTypes.string().def(''),
  icon: propTypes.string().def(''),
  duration: propTypes.number().def(2000),
  showMask: propTypes["boolean"]().def(false),
  transition: propTypes.string().def('toast-transition')
};

var _components;
var _createComponent = createComponent('toast'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: (_components = {}, _defineProperty(_components, Popup.name, Popup), _defineProperty(_components, Icon.name, Icon), _defineProperty(_components, Loading.name, Loading), _components),
  props: props,
  setup: function setup(props) {
    var state = reactive({
      status: props.status,
      icon: props.icon,
      content: props.content,
      duration: props.duration,
      showMask: props.showMask,
      visible: false
    });
    var timer;
    var isShowIcon = computed(function () {
      if (state.status === 'info') {
        // 如果状态是文本提示，则不展示
        return false;
      }
      return !!state.icon;
    });
    var classNames = [className, props.token];
    var classes = computed(function () {
      return ["".concat(className, "__content"), _defineProperty({}, "".concat(className, "__").concat(state.status), state.status)];
    });
    // 文本提示最多展示30个字，其他状态最多展示7个字。 超出将被截断。
    var tipsText = computed(function () {
      return String(state.content).slice(0, state.status === 'info' ? 30 : 7);
    });
    function hide() {
      state.visible = false;
    }
    function init() {
      clearTimeout(timer);
      if (state.visible && state.duration) {
        timer = setTimeout(function () {
          hide();
        }, state.duration);
      }
    }
    onMounted(function () {
      init();
    });
    onUpdated(function () {
      init();
    });
    onBeforeUnmount(function () {
      if (state.duration) {
        clearTimeout(timer);
      }
    });
    return {
      classNames: classNames,
      className: className,
      isShowIcon: isShowIcon,
      classes: classes,
      hide: hide,
      tipsText: tipsText,
      state: state
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_loading = resolveComponent("sp-loading");
  var _component_sp_icon = resolveComponent("sp-icon");
  var _component_sp_popup = resolveComponent("sp-popup");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.classNames)
  }, [createVNode(_component_sp_popup, {
    modelValue: _ctx.state.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.state.visible = $event;
    }),
    "show-mask": _ctx.state.showMask,
    "mask-closeable": false,
    "disable-scroll": false,
    transition: _ctx.transition,
    position: "center",
    transferDom: false
  }, {
    "default": withCtx(function () {
      return [createElementVNode("div", {
        "class": normalizeClass(_ctx.classes)
      }, [_ctx.isShowIcon ? (openBlock(), createElementBlock(Fragment, {
        key: 0
      }, [_ctx.state.status === 'loading' ? (openBlock(), createBlock(_component_sp_loading, {
        key: 0,
        size: 48,
        type: "white",
        "class": normalizeClass("".concat(_ctx.className, "__icon"))
      }, null, 8 /* PROPS */, ["class"])) : createCommentVNode("v-if", true), createVNode(_component_sp_icon, {
        name: _ctx.state.icon,
        size: "48",
        "class": normalizeClass("".concat(_ctx.className, "__icon"))
      }, null, 8 /* PROPS */, ["name", "class"])], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true), createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__text"))
      }, toDisplayString(_ctx.tipsText), 3 /* TEXT, CLASS */)], 2 /* CLASS */)];
    }),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "show-mask", "transition"])], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/toast/toast.vue";

var instance;
// 获取kid-token对应的status
function getToastStatusForToken(token) {
  return toast[token] && toast[token].status || 'info';
}
var generate = function generate(_props) {
  var _props$content = _props.content,
    content = _props$content === void 0 ? '' : _props$content,
    _props$icon = _props.icon,
    icon = _props$icon === void 0 ? '' : _props$icon,
    _props$status = _props.status,
    status = _props$status === void 0 ? 'info' : _props$status,
    _props$duration = _props.duration,
    duration = _props$duration === void 0 ? 2000 : _props$duration,
    _props$showMask = _props.showMask,
    showMask = _props$showMask === void 0 ? false : _props$showMask,
    parentNode = _props.parentNode;
  var props = {
    content: content,
    icon: icon,
    status: status,
    duration: duration,
    showMask: showMask
  };
  var vm = instance;
  if (!vm) {
    vm = createApp(script, _objectSpread2({}, props)).mount(document.createElement('div'));
    var parent = parentNode || document.body;
    parent.appendChild(vm.$el);
    instance = vm;
  }
  vm.state.content = props.content;
  vm.state.icon = props.icon;
  vm.state.status = props.content.length > 7 ? 'info' : props.status;
  vm.state.duration = props.duration;
  vm.state.showMask = props.showMask;
  vm.state.visible = true;
  return vm;
};
script.info = function () {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  var showMask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var parentNode = arguments.length > 3 ? arguments[3] : undefined;
  return generate({
    content: content,
    icon: '',
    status: 'info',
    duration: duration,
    showMask: showMask,
    parentNode: parentNode
  });
};
script.success = function () {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  var showMask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var parentNode = arguments.length > 3 ? arguments[3] : undefined;
  return generate({
    content: content,
    icon: 'tost_success',
    status: 'success',
    duration: duration,
    showMask: showMask,
    parentNode: parentNode
  });
};
script.error = function () {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  var showMask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var parentNode = arguments.length > 3 ? arguments[3] : undefined;
  return generate({
    content: content,
    icon: 'tost_error',
    status: 'error',
    duration: duration,
    showMask: showMask,
    parentNode: parentNode
  });
};
script.warn = function () {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  var showMask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var parentNode = arguments.length > 3 ? arguments[3] : undefined;
  return generate({
    content: content,
    icon: 'tost_error',
    status: 'warn',
    duration: duration,
    showMask: showMask,
    parentNode: parentNode
  });
};
script.loading = function () {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '正在加载';
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  var showMask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var parentNode = arguments.length > 3 ? arguments[3] : undefined;
  return generate({
    content: content,
    icon: 'spinner',
    status: 'loading',
    duration: duration,
    showMask: showMask,
    parentNode: parentNode
  });
};
script.show = function (props) {
  if (props.token) {
    var token = props.token,
      content = props.content,
      duration = props.duration,
      showMask = props.showMask,
      parentNode = props.parentNode;
    var status = getToastStatusForToken(token);
    var toastMethod = script.info;
    switch (status) {
      case 'success':
        toastMethod = script.success;
        break;
      case 'error':
        toastMethod = script.error;
        break;
      case 'warn':
        toastMethod = script.warn;
        break;
      case 'loading':
        toastMethod = script.loading;
        break;
      case 'info':
      default:
        toastMethod = script.info;
    }
    return toastMethod(content, duration, showMask, parentNode);
  }
  return generate(Object.assign({
    content: '',
    icon: '',
    status: 'info',
    duration: 2000,
    showMask: false
  }, props));
};
script.hide = function () {
  if (instance && instance.state.visible) {
    instance.hide();
  }
};
var _Toast = script;

export { _Toast as default };
